// extracted by mini-css-extract-plugin
module.exports =  {"dialogContainer":"dialogContainer__oWTMW","borders":"borders__8YQNN"};